import React, { Component } from "react";
import { Auth } from "aws-amplify";
import axios from "axios";
import { Redirect } from "react-router-dom";
import logo from "../assets/icontransparent.png";
import { putDashboardUser } from "./authService";

const config = require("../../config.json");

const STATIC_PASSWORD = "klimakampen2026";

class LogIn extends Component {
  state = {
    loginEmail: "",
    loginPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    loginError: "",
    loginLoading: false,
    cognitoUser: null,
  };

  getCompanyFromEmail = async (email) => {
    const response = await axios.post(
      `${config.api.invokeUrl}/users/companycheck`,
      { email },
    );

    return response.data;
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const { loginEmail, loginPassword } = this.state;

    if (!loginEmail || !loginPassword) {
      this.setState({ loginError: "Udfyld venligst begge felter" });
      return;
    }

    this.setState({ loginLoading: true, loginError: "" });

    try {
      const user = await Auth.signIn(loginEmail, loginPassword);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        this.setState({
          cognitoUser: user,
          loginLoading: false,
          loginError: "",
        });
        return;
      }

      await this.props.auth.setSession();
      this.props.history.push("/");
      return;
    } catch (adminError) {
      if (adminError.code === "PasswordResetRequiredException") {
        this.setState({
          loginError: "Brugeren skal have oprettet en ny adgangskode først.",
          loginLoading: false,
        });
        return;
      }

      if (loginPassword !== STATIC_PASSWORD) {
        this.setState({
          loginError: "Forkert adgangskode",
          loginLoading: false,
        });
        return;
      }
    }

    try {
      const data = await this.getCompanyFromEmail(loginEmail);
      const companyId = data.company;

      if (!companyId) {
        this.setState({
          loginError: "Ingen virksomhed fundet for denne email",
          loginLoading: false,
        });
        return;
      }

      const dashboardUser = {
        username: loginEmail,
        email: loginEmail,
        companyId,
        admin: false,
        authType: "dashboard",
      };

      putDashboardUser(dashboardUser);
      this.props.auth.setDashboardSession(dashboardUser);
      this.props.history.push("/");
    } catch (error) {
      console.log(error);
      const loginError =
        error.response?.status === 404
          ? "Ingen bruger fundet med denne email"
          : "Noget gik galt. Prøv igen.";

      this.setState({
        loginError,
        loginLoading: false,
      });
    }
  };

  handleNewPasswordSubmit = async (event) => {
    event.preventDefault();

    const { cognitoUser, newPassword, confirmNewPassword } = this.state;

    if (!newPassword || !confirmNewPassword) {
      this.setState({ loginError: "Udfyld venligst begge felter" });
      return;
    }

    if (newPassword !== confirmNewPassword) {
      this.setState({ loginError: "De nye adgangskoder matcher ikke" });
      return;
    }

    this.setState({ loginLoading: true, loginError: "" });

    try {
      await Auth.completeNewPassword(cognitoUser, newPassword);
      this.setState({
        cognitoUser: null,
        newPassword: "",
        confirmNewPassword: "",
      });
      await this.props.auth.setSession();
      this.props.history.push("/");
    } catch (error) {
      console.log(error);
      this.setState({
        loginError: error.message || "Kunne ikke opdatere adgangskoden",
        loginLoading: false,
      });
    }
  };

  onInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    if (this.props.auth.checkAuth()) {
      return <Redirect to="/" />;
    }

    const requiresNewPassword = Boolean(this.state.cognitoUser);

    return (
      <section className="section dashboard">
        <div className="login-container">
          <div className="login-card">
            <img className="login-logo" src={logo} alt="Klimakampen" />
            <h1 className="login-title">Klimakampen</h1>
            <p className="login-subtitle">
              {requiresNewPassword
                ? "Du skal vælge en ny adgangskode for at fortsætte"
                : "Log ind for at se dit dashboard"}
            </p>
            <form
              onSubmit={
                requiresNewPassword
                  ? this.handleNewPasswordSubmit
                  : this.handleSubmit
              }
              className="login-form"
            >
              {!requiresNewPassword && (
                <>
                  <input
                    type="text"
                    name="loginEmail"
                    className="login-input"
                    placeholder="Email eller brugernavn"
                    value={this.state.loginEmail}
                    onChange={this.onInputChange}
                    autoFocus
                  />
                  <input
                    type="password"
                    name="loginPassword"
                    className="login-input"
                    placeholder="Adgangskode"
                    value={this.state.loginPassword}
                    onChange={this.onInputChange}
                  />
                </>
              )}
              {requiresNewPassword && (
                <>
                  <input
                    type="password"
                    name="newPassword"
                    className="login-input"
                    placeholder="Ny adgangskode"
                    value={this.state.newPassword}
                    onChange={this.onInputChange}
                    autoFocus
                  />
                  <input
                    type="password"
                    name="confirmNewPassword"
                    className="login-input"
                    placeholder="Gentag ny adgangskode"
                    value={this.state.confirmNewPassword}
                    onChange={this.onInputChange}
                  />
                </>
              )}
              {this.state.loginError && (
                <p className="login-error">{this.state.loginError}</p>
              )}
              <button
                type="submit"
                className="login-button"
                disabled={this.state.loginLoading}
              >
                {this.state.loginLoading ? (
                  <div className="login-spinner"></div>
                ) : (
                  requiresNewPassword ? "Opdater adgangskode" : "Log ind"
                )}
              </button>
            </form>
          </div>
        </div>
      </section>
    );
  }
}

export default LogIn;
